var _defs, _g, _rect, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLuckyDrawIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.069,
    y1: -0.147,
    x2: 0.84,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5752",
    "data-name": "Rectangle 5752",
    width: 40,
    height: 32,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35977",
    "data-name": "Group 35977",
    transform: "translate(-21 -302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35976",
    "data-name": "Group 35976"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35528",
    "data-name": "Group 35528"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5513",
    "data-name": "Rectangle 5513",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5523",
    "data-name": "Rectangle 5523",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "#fc3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35542",
    "data-name": "Group 35542",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5513-2",
    "data-name": "Rectangle 5513",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5523-2",
    "data-name": "Rectangle 5523",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35975",
    "data-name": "Group 35975",
    transform: "translate(34 322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35974",
    "data-name": "Group 35974",
    transform: "translate(2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_507",
    "data-name": "Line 507",
    y2: 4,
    transform: "translate(26 2)",
    fill: "none",
    stroke: "#040504",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_508",
    "data-name": "Line 508",
    y2: 4,
    transform: "translate(26 26)",
    fill: "none",
    stroke: "#040504",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39648",
    "data-name": "Path 39648",
    d: "M35.865,31.864h28a4,4,0,0,1,4,4v6a4,4,0,1,0,0,8v6a4,4,0,0,1-4,4h-28a4,4,0,0,1-4-4v-6a4,4,0,0,0,0-8v-6a4,4,0,0,1,4-4",
    transform: "translate(-29.865 -29.864)",
    fill: "none",
    stroke: "#040504",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39649",
    "data-name": "Path 39649",
    d: "M276.7,299.107l-.246,2.774.246,2.774,2.4-1.387,2.4-1.387-2.156-1.633Z",
    transform: "translate(-259.099 -280.334)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39650",
    "data-name": "Path 39650",
    d: "M353.237,254.917l-.246,2.774.246,2.774,2.4-1.387,2.4-1.387-2.156-1.633Z",
    transform: "translate(-330.835 -238.917)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39651",
    "data-name": "Path 39651",
    d: "M353.237,172.08l-.246-2.774.246-2.774,2.4,1.387,2.4,1.387-2.156,1.633Z",
    transform: "translate(-330.835 -156.08)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39652",
    "data-name": "Path 39652",
    d: "M356.918,213.5l2.4-1.387,2.4-1.387v5.547l-2.4-1.387Z",
    transform: "translate(-334.515 -197.498)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39653",
    "data-name": "Path 39653",
    d: "M276.7,127.889l-.246-2.774.246-2.774,2.4,1.387,2.4,1.387-2.156,1.633Z",
    transform: "translate(-259.099 -114.663)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39654",
    "data-name": "Path 39654",
    d: "M280.376,169.307l2.4-1.387,2.4-1.387v5.547l-2.4-1.387Z",
    transform: "translate(-262.778 -156.081)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39655",
    "data-name": "Path 39655",
    d: "M203.833,129.28h4.8v-6.937l-2.4,1.387-2.4,1.387",
    transform: "translate(-191.04 -114.664)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39656",
    "data-name": "Path 39656",
    d: "M203.833,276.965h4.8V283.9l-2.4-1.387-2.4-1.387",
    transform: "translate(-191.04 -259.582)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39657",
    "data-name": "Path 39657",
    d: "M280.376,257.689l2.4,1.387,2.4,1.387v-5.547l-2.4,1.387Z",
    transform: "translate(-262.778 -238.916)",
    fill: "#080909",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLuckyDrawIcon);
export default __webpack_public_path__ + "static/media/profile-lucky-draw-icon.4778591000bed438ef8e9bcef7a2f8a1.svg";
export { ForwardRef as ReactComponent };